import axiosGraphQL from './GraphQL/axiosGraphQL';
import { RewardCalculationQueries } from './GraphQL/Queries/RewardCalculationQueries';
import {
  ICalculateRewardForPlant,
  ICalculateRewardForTeam,
  IUpdateHotRewardAmount,
  RewardCalculationVariables,
} from './GraphQL/Variables/RewardCalculationVariables';

export const RewardCalculationApis = {
  getRewardCalculation: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardCalculationQueries.GET_REWARD_CALCULATION,
      variables: RewardCalculationVariables.getRewardCalculation(params),
    });
  },

  rewardCalculation: async (params: {
    userId: string;
    fromDate: string | Date;
    toDate: string | Date;
  }): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardCalculationQueries.REWARD_CALCULATION,
      variables: RewardCalculationVariables.rewardCalculation(params),
    });
  },

  saveRewardCalculation: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardCalculationQueries.SAVE_REWARD_CALCULATION,
      variables: RewardCalculationVariables.saveRewardCalculation(params),
    });
  },

  calculateRewardForTeam: async (
    params: ICalculateRewardForTeam,
  ): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardCalculationQueries.CALCULATE_REWARD_FOR_TEAM_SALE,
      variables: RewardCalculationVariables.calculateRewardForTeam(params),
    });
  },

  calculateRewardForPlant: async (
    params: ICalculateRewardForPlant,
  ): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardCalculationQueries.CALCULATE_REWARD_FOR_PLANT,
      variables: RewardCalculationVariables.calculateRewardForPlant(params),
    });
  },

  updateHotRewardAmount: async (
    params: IUpdateHotRewardAmount,
  ): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardCalculationQueries.UPDATE_HOT_REWARD_AMOUNT,
      variables: RewardCalculationVariables.updateHotRewardAmount(params),
    });
  },
};
